import React,  {useState} from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { Link } from 'react-router-dom';

const OrderList = ({ orders }) => {
    const uniqueOrders = Array.from(new Set(orders.split(',')));
    const [expanded, setExpanded] = useState(false);
    const hasMore = uniqueOrders.length > 3;
    const visibleOrders = expanded ? uniqueOrders : uniqueOrders.slice(0, 3);
  
    return (
      <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 m-0 p-0">
        <label>Orders</label>
        <div className="grey-text">
          {visibleOrders.map((order) => (
            <p key={order} className="m-0 fw_bold">
              <Link to={`/admin/orders/detail/${order}`} target="_blank">
                #{order}
              </Link>
            </p>
          ))}
          {hasMore && (
            <button
              className="btn btn-link p-0 mt-1"
              onClick={() => setExpanded(!expanded)}
              style={{ fontSize: '0.9rem' }}
            >
              {expanded ? 'Show less' : `+${uniqueOrders.length - 3} more`}
            </button>
          )}
        </div>
      </div>
    );
  };

const Body = ({ customerSales, endDate, beginDate, isHighTide }) => (

    <div>
        {
            customerSales.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                customerSales.length > 0 &&
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        {
                            customerSales.map((item, index) => {
                                const uniqueOrders = [];
                                item.orders.split(',').map((oitem) => {
                                    var findItem = uniqueOrders.find((x) => x === oitem);
                                    if (!findItem) uniqueOrders.push(oitem);
                                });
                                return (
                                    <div className="row m-0 mb-2 mt-2 border_bottom_grey" key={index}>

                                        <div className="col-lg-2 text-center border-right mb-1">
                                            <h4 className="m-0 black-text"><Link to={`/member/${item.id}`}>{item.firstName + " " + item.lastName}
                                                { item.isEmployee === 1 ? " (EMPLOYEE)" :
                                                    (item.isElite === 1 ? " (ELITE) " : 
                                                    (isHighTide ? " (NON-ELITE)" : " (MEMBER)")
                                                    )
                                                }
                                                </Link></h4>
                                            <h5 className="m-0 grey-text">Member ID: {item.id}</h5>
                                            <h5 className="m-0 grey-text">{item.identificationNumber && item.identificationType + ": " + item.identificationNumber}</h5>
                                        </div>

                                        <div className="col-lg-9 text-center ">

                                            <div className="row m-0 mb-2 border-bottom">

                                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 m-0 p-0 ">
                                                    <label>Total Net Sales</label>
                                                    <h4 className="m-0 grey-text">{getDollarFormat(item.totalSales)}</h4>
                                                </div>

                                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 ">
                                                    <label>Orders</label>
                                                    <h4 className="m-0 grey-text">{item.numOfOrders}</h4>
                                                </div>

                                                <OrderList orders={item.orders}/>

                                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6  m-0 p-0 ">
                                                    <label>Average Net Sale Per Order</label>
                                                    <h4 className="m-0 grey-text">{getDollarFormat(item.averagePerOrder)}</h4>
                                                </div>


                                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6  m-0 p-0 ">
                                                    <label>Number of Items</label>
                                                    <h4 className="m-0 grey-text">{item.numberOfItems}</h4>
                                                </div>

                                                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6  m-0 p-0 ">
                                                    <label>Total Member Saving</label>
                                                    <h4 className="m-0 grey-text">{getDollarFormat(item.totalMemberSavings)}</h4>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

export default Body;